import { createGtm } from 'vue-gtm'

const gtmId = process.env.VUE_APP_GTM_ID
export const gtmPlugin = gtmId ? createGtm({ id: gtmId }) : null
